import { render, staticRenderFns } from "./content-info.vue?vue&type=template&id=147c29e4&scoped=true"
import script from "./content-info.ts?vue&type=script&lang=ts&external"
export * from "./content-info.ts?vue&type=script&lang=ts&external"
import style0 from "./content-info.scss?vue&type=style&index=0&id=147c29e4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c29e4",
  null
  
)

export default component.exports